import { Controller } from "@hotwired/stimulus"
import { ScrollSpy } from "bootstrap"

/**
 * ScrollSpy Controller
 * Wraps Bootstrap ScrollSpy so it reinitializes on Turbo Stream replacements
 *
 * Usage:
 * <div data-controller="scrollspy"
 *      data-scrollspy-target-value="#nav-product-sections"
 *      data-scrollspy-root-margin-value="0px 0px -40%"
 *      data-scrollspy-smooth-scroll-value="true">
 */
export default class extends Controller {
  static values = {
    target: String,
    rootMargin: { type: String, default: "0px 0px -40%" },
    smoothScroll: { type: Boolean, default: true }
  }

  connect() {
    this.scrollspy = new ScrollSpy(this.element, {
      target: this.targetValue,
      rootMargin: this.rootMarginValue,
      smoothScroll: this.smoothScrollValue
    })
  }

  disconnect() {
    this.scrollspy?.dispose()
  }
}

